import gql from 'graphql-tag';
import { take, tap, pluck, withLatestFrom } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
import * as i2 from "apollo-angular/Apollo";
// * QUERY FILTRO MAQUINA
const QUERY_clientes_registros = gql `
  query ($filtro: FiltroInputTypeOfmaquina_inventarioTOmaquina_inventarioInputType, $sucursal: [Decimal], $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
    maquina_inventario {
      obtenerSegunFiltroClienteExcel(filtro: $filtro, sucursal: $sucursal, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
        mensajes {
          codigo
          texto
          tipo
        }
        respuesta {
          paginaActual
          cantidadRegistrosPorPagina
          totalPaginas
          totalRegistros
          registros {
            direccion
            nombre_comuna
            nombre_ciudad
            ubicacion
            contacto
            placa
            marca
            modelo
            estado
            estado_maquina_codigo
          }
        }
      }
    }
  }
`;
const Query_inventarioFiltroVendedor = gql `
  query ($filtro: FiltroInputTypeOfmaquina_inventarioTOmaquina_inventarioInputType, $vendedor: [Decimal], $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
    maquina_inventario {
      obtenerSegunFiltroVendedorExcel(filtro: $filtro, vendedor: $vendedor, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
        mensajes {
          codigo
          texto
          tipo
        }
        respuesta {
          paginaActual
          cantidadRegistrosPorPagina
          totalPaginas
          totalRegistros
          registros {
            cliente_proveedor_rut
            cliente_proveedor_nombre
            direccion
            nombre_comuna
            nombre_ciudad
            placa
            marca
            modelo
            estado_maquina_codigo
            estado
            vendedor_codigo
            nombre_vendedor
            dia
            conteo
          }
        }
      }
    }
  }
`;
const Query_reporte_antiguedad = gql `
  query ($filtro: FiltroInputTypeOfmaquina_inventarioTOmaquina_inventarioInputType, $estado: [Decimal], $grupo: [Decimal], $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
    maquina_inventario {
      obtenerReporteAntiguedadExcel(filtro: $filtro, estado: $estado, grupo: $grupo, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
        respuesta {
          paginaActual
          cantidadRegistrosPorPagina
          totalPaginas
          totalRegistros
          registros {
            grupo_nombre
            conteo1
            conteo2
            conteo3
            conteo4
            conteo_total
          }
        }
      }
    }
  }
`;
export class MaquinaInventarioService {
    constructor(gqlclient, apollo) {
        this.gqlclient = gqlclient;
        this.apollo = apollo;
        this.clientesDataSubject = new BehaviorSubject(null);
        this.Clientess$ = this.clientesDataSubject.asObservable();
    }
    //* DEVUELVE OBSERVABLE CON LA RESPUESTA DE LA QUERY
    GetSegunFiltroCliente(inputParams) {
        this.postsQuery = this.apollo.watchQuery({
            query: QUERY_clientes_registros,
            variables: inputParams,
            fetchPolicy: 'network-only',
        });
        this.queryCliente = this.postsQuery.valueChanges.pipe(take(1), pluck('data', 'maquina_inventario'), withLatestFrom(this.Clientess$), tap(([apiResponse, respuesta]) => {
            return apiResponse.obtenerSegunFiltroClienteExcel.respuesta;
        }));
    }
    //* DEVUELVE OBSERVABLE CON LA RESPUESTA DE LA QUERY VENDEDOR
    GetSegunFiltroVendedor(inputParams) {
        this.postsQuery = this.apollo.watchQuery({
            query: Query_inventarioFiltroVendedor,
            variables: inputParams,
            fetchPolicy: 'network-only',
        });
        this.queryCliente = this.postsQuery.valueChanges.pipe(take(1), pluck('data', 'maquina_inventario'), withLatestFrom(this.Clientess$), tap(([apiResponse, respuesta]) => {
            return apiResponse.obtenerSegunFiltroVendedorExcel.respuesta;
        }));
    }
    //* DEVUELVE OBSERVABLE CON LA RESPUESTA DE LA QUERY
    getReporteAntiguedad(inputParams) {
        this.postsQuery = this.apollo.watchQuery({
            query: Query_reporte_antiguedad,
            variables: inputParams,
            fetchPolicy: 'network-only',
        });
        this.queryCliente = this.postsQuery.valueChanges.pipe(take(1), pluck('data', 'maquina_inventario'), withLatestFrom(this.Clientess$), tap(([apiResponse, respuesta]) => {
            return apiResponse.obtenerReporteAntiguedadExcel.respuesta;
        }));
    }
    obtenerSegunFiltroCliente(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($filtro: FiltroInputTypeOfmaquina_inventarioTOmaquina_inventarioInputType, $sucursal: [Decimal], $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            maquina_inventario {
              obtenerSegunFiltroClienteExcel(filtro: $filtro, sucursal: $sucursal, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    direccion
                    nombre_comuna
                    nombre_ciudad
                    ubicacion
                    contacto
                    placa
                    marca
                    modelo
                    estado
                    estado_maquina_codigo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.maquina_inventario.obtenerSegunFiltroClienteExcel;
            callback({ mensajes, respuesta });
        });
    }
    obtenerSegunFiltroClienteExcelPdf(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($filtro: FiltroInputTypeOfmaquina_inventarioTOmaquina_inventarioInputType) {
            maquina_inventario {
              obtenerSegunFiltroClienteExcel(filtro: $filtro) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.maquina_inventario.obtenerSegunFiltroClienteExcel;
            callback({ mensajes, respuesta });
        });
    }
    obtenerSegunFiltroVendedor(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($filtro: FiltroInputTypeOfmaquina_inventarioTOmaquina_inventarioInputType, $vendedor: [Decimal], $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            maquina_inventario {
              obtenerSegunFiltroVendedorExcel(filtro: $filtro, vendedor: $vendedor, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    cliente_proveedor_rut
                    cliente_proveedor_nombre
                    direccion
                    nombre_comuna
                    nombre_ciudad
                    placa
                    marca
                    modelo
                    estado_maquina_codigo
                    estado
                    vendedor_codigo
                    nombre_vendedor
                    dia
                    conteo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.maquina_inventario.obtenerSegunFiltroVendedorExcel;
            callback({ mensajes, respuesta });
        });
    }
    obtenerSegunFiltroVendedorExcelPDF(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($filtro: FiltroInputTypeOfmaquina_inventarioTOmaquina_inventarioInputType, $vendedor: [Decimal]) {
            maquina_inventario {
              obtenerSegunFiltroVendedorExcel(filtro: $filtro, vendedor: $vendedor) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.maquina_inventario.obtenerSegunFiltroVendedorExcel;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteClienteResumen(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($filtro: FiltroInputTypeOfmaquina_inventarioTOmaquina_inventarioInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            maquina_inventario {
              obtenerReporteClienteResumen(filtro: $filtro, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo_sucursal
                    cliente_proveedor_rut
                    cliente
                    direccion
                    nombre_comuna
                    nombre_ciudad
                    estado_maquina_codigo
                    monto_total
                    monto_maquina
                    conteo_total
                    territorio
                    vendedor_codigo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.maquina_inventario.obtenerReporteClienteResumen;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteClienteDetalle(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($filtro: FiltroInputTypeOfmaquina_inventarioTOmaquina_inventarioInputType, $estado: [Decimal], $familia: [Decimal], $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            maquina_inventario {
              obtenerReporteClienteDetalle(filtro: $filtro, estado: $estado, familia: $familia, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo_sucursal
                    cliente_proveedor_rut
                    cliente
                    direccion
                    nombre_comuna
                    nombre_ciudad
                    placa
                    marca
                    modelo
                    numero_contrato
                    guia_despacho
                    fecha_ult_asignacion
                    estado
                    estado_maquina_codigo
                    monto_total
                    monto_maquina
                    conteo_total
                    territorio
                    estado_maquina_codigo
                    vendedor_codigo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.maquina_inventario.obtenerReporteClienteDetalle;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteClienteExcelPdfResumen(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($filtro: FiltroInputTypeOfmaquina_inventarioTOmaquina_inventarioInputType) {
            maquina_inventario {
              obtenerReporteClienteResumen(paginaActual: 1, filtro: $filtro) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.maquina_inventario.obtenerReporteClienteResumen;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteClienteExcelPdfDetalle(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($filtro: FiltroInputTypeOfmaquina_inventarioTOmaquina_inventarioInputType, $estado: [Decimal], $familia: [Decimal]) {
            maquina_inventario {
              obtenerReporteClienteDetalle(paginaActual: 1, filtro: $filtro, estado: $estado, familia: $familia) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.maquina_inventario.obtenerReporteClienteDetalle;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteAntiguedad(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($filtro: FiltroInputTypeOfmaquina_inventarioTOmaquina_inventarioInputType, $estado: [Decimal], $grupo: [Decimal], $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            maquina_inventario {
              obtenerReporteAntiguedadExcel(filtro: $filtro, estado: $estado, grupo: $grupo, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    grupo_nombre
                    conteo1
                    conteo2
                    conteo3
                    conteo4
                    conteo_total
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.maquina_inventario.obtenerReporteAntiguedadExcel;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteAntiguedadExcelPdf(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($filtro: FiltroInputTypeOfmaquina_inventarioTOmaquina_inventarioInputType, $estado: [Decimal], $grupo: [Decimal]) {
            maquina_inventario {
              obtenerReporteAntiguedadExcel(paginaActual: 1, filtro: $filtro, estado: $estado, grupo: $grupo) {
                respuesta {
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.maquina_inventario.obtenerReporteAntiguedadExcel;
            callback({ mensajes, respuesta });
        });
    }
}
MaquinaInventarioService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MaquinaInventarioService_Factory() { return new MaquinaInventarioService(i0.ɵɵinject(i1.GraphQLClient), i0.ɵɵinject(i2.Apollo)); }, token: MaquinaInventarioService, providedIn: "root" });
